<div class="column">
    <div class="task--search-bar">
        <mat-form-field appearance="outline" class="search--input">
            <mat-label>Search</mat-label>
            <input matInput type="text" placeholder="Type member name to find" [(ngModel)]="query" (ngModelChange)="onSearch()">
            <button matSuffix mat-icon-button>
                <mat-icon>search</mat-icon>
              </button>
          </mat-form-field>
        
         

 <div class="task--search-bar-items">
            <app-icon-detail [model]="this.userModel"></app-icon-detail>
            <button class="continue" (click)="addMember()" mat-button> <mat-icon>open_in_new</mat-icon>
              ADD MEMBER</button>
    </div>
    </div>
    <div class="mat-elevation-z8">
      <table   mat-table matSort aria-label="Elements">

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
          <td mat-cell *matCellDef="let row">{{row.id}}</td>
        </ng-container>
    
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First name</th>
          <td mat-cell *matCellDef="let row">{{row.firstName}}</td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last name</th>
          <td mat-cell *matCellDef="let row">{{row.lastName}}</td>
        </ng-container>

        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email address</th>
          <td mat-cell *matCellDef="let row">{{row.userName}}</td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone number</th>
          <td mat-cell *matCellDef="let row">{{row.phoneNumber}}</td>
        </ng-container>


        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let row">
            <app-status-indicator [statusText]="mapstatus(row.status)"></app-status-indicator>
          </td>
        </ng-container>
   

      
        <ng-container matColumnDef="actions">
          <th style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element;let i=index;">   <mat-icon style="color: #C62828;" class="icon-pointer" (click)="removeUser(element)" aria-label="Edit">delete_outline</mat-icon>    </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr  mat-row *matRowDef="let row; columns: displayedColumns;"
      ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No data matching the filter.
          </td>
        </tr>
      </table>
      <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
    </mat-paginator>
    </div>
</div>

